"use strict";

var SwipeDirection;
Object.defineProperty(exports, "__esModule", {
  value: !0
}), function (e) {
  e[e.up = 0] = "up", e[e.down = 1] = "down";
}(SwipeDirection = exports.SwipeDirection || (exports.SwipeDirection = {}));